<template>
  <div id="app">

    <!--照片-->
    <div class="loose-container" v-if="showImg && currentIndex">
      <div class="name-card-container">
        <p class="name-text">恭喜你获得【{{currentItem.compony}}】的名片！</p>
        <img class="name-card" :src="imgurl" alt="">
      </div>
    </div>

    <div class="end-cover" v-if="showEndCover && !showShare">
      <img class="title-img" src="https://upload-images.jianshu.io/upload_images/6185311-1eb7eb4cb917f3a0.png?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240" alt="">
      <div class="btn2-container">
        <img class="left" src="https://upload-images.jianshu.io/upload_images/6185311-c6c425b424cc0915.png?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240" @click="rePlay" alt="">
        <img class="right" src="https://upload-images.jianshu.io/upload_images/6185311-dc2f95249acf894f.png?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240" @click="goShare" alt="">
      </div>
      <div class="code-container">
        <img class="code-img" src="https://upload-images.jianshu.io/upload_images/6185311-304b3783cde4bc4b.png?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240" alt="">
      </div>
    </div>

    <div class="shareLayer" v-if="showShare">
      <img  class="share-img" src="http://h0.hucdn.com/open201917/653e7abb562b12a9_444x252.png" alt="">
    </div>

    <div class="tip-text" v-show="showTips"> 松开手指，可以获得该公司『一带一路专属名片』哦 ~ </div>
    <!-- 文字 -->
    <div class="text-container" :class="showImg ? 'whitetext' : ''" v-if="currentItem">
      <div class="name">{{currentItem.name}}</div>
      <div class="compony">企业：【{{currentItem.compony}}】</div>
      <div class="desc" v-html="currentItem.text"></div>
    </div>

    <!-- 开始播放的提示 -->
    <div class="and-tip-start" v-if="beforePlay" @click="handleVideoClick">点击屏幕开始领略一带一路</div>

    <!-- 长按的提示 -->
    <div class="btn-container" v-if="showStartText" v-on:click="onTouchStart" v-on:touchstart="onTouchStart" v-on:touchend.prevent="onTouchEnd"></div>

    <!-- 音频 -->
    <audio id="audio" preload="auto" class="audio" autoplay="autoplay" src="http://h0.hucdn.com/openAudio201917/7ad12b21af2d0bc6.mp3" loop></audio>
    <!-- 视频 -->
    <div class="video-container">
      <div class="video-item">
        <!-- 在没有播放的时候，显示video背景图-->
        <video id="video" :class="videoIsBegin?'normalbg':'beginbg'" controls="" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto" src="http://pqajsnee9.bkt.clouddn.com/%E5%A3%B0%E9%9F%B3_2.mov"></video>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import text from './text.json'
import cardArr from './card.js'
export default {
  name: 'App',
  computed: {
    imgurl () {
      return `${this.cardArr[this.currentIndex - 1]}`
    }
  },
  data () {
    return {
      beforePlay: true,
      btnElm: document.getElementById('video'),
      // 视频开始播放
      videoIsBegin: false,
      // 视频可以播放
      videoCanplay: false,
      // 已经经历过开头了
      hasPreview: false,
      showStartText: false,
      currentItem: '',
      currentIndex: '',
      showImg: false,
      hasCard: [],
      videoIsEnd: false,
      showEndCover: false,
      showTips: false,
      textArr: text,
      showShare: false,
      cardArr: cardArr
    }
  },
  methods: {
    listenUpdate () {
      // 监听播放时间
      var video = document.getElementById('video')
      // 使用事件监听方式捕捉事件
      video.addEventListener('timeupdate', () => {
        var timeDisplay
        // 用秒数来显示当前播放进度
        timeDisplay = Number(video.currentTime.toFixed(2))

        if (timeDisplay > 2 && timeDisplay < 2.5 && !this.hasPreview) {
          video.pause()
          this.hasPreview = true
          this.showStartText = true
        } else if (timeDisplay > 3.2 && timeDisplay < 5.3) {
          this.currentIndex = 1
          this.currentItem = text['1']
        } else if (timeDisplay > 3.2 && timeDisplay < 9) {
          this.currentIndex = 2
          this.currentItem = text['2']
          this.showTips = true
        } else if (timeDisplay > 9.1 && timeDisplay < 10.5) {
          this.currentIndex = 3
          this.currentItem = text['3']
          this.showTips = false
        } else if (timeDisplay > 11 && timeDisplay < 14) {
          this.currentIndex = 4
          this.currentItem = text['4']
        } else if (timeDisplay > 15.2 && timeDisplay < 19.9) {
          this.currentIndex = 5
          this.currentItem = text['5']
        } else if (timeDisplay > 20.5 && timeDisplay < 25) {
          this.currentIndex = 6
          this.currentItem = text['6']
        } else if (timeDisplay > 25.5 && timeDisplay < 28.5) {
          this.currentIndex = 7
          this.currentItem = text['7']
          this.showTips = true
        } else if (timeDisplay > 29.1 && timeDisplay < 31.5) {
          this.currentIndex = 8
          this.currentItem = text['8']
          this.showTips = false
        } else if (timeDisplay > 32.5 && timeDisplay < 36) {
          this.currentIndex = 9
          this.currentItem = text['9']
        } else if (timeDisplay > 36.5 && timeDisplay < 40.5) {
          this.currentIndex = 10
          this.currentItem = text['10']
        } else if (timeDisplay > 40.8 && timeDisplay < 45.5) {
          this.currentIndex = 11
          this.currentItem = text['11']
        } else if (timeDisplay > 46.5 && timeDisplay < 51) {
          this.currentIndex = 12
          this.currentItem = text['12']
        } else if (timeDisplay > 51 && timeDisplay < 56) {
          this.currentIndex = 13
          this.currentItem = text['13']
          this.showTips = true
        } else if (timeDisplay > 56.6 && timeDisplay < 60.5) {
          this.currentIndex = 14
          this.currentItem = text['14']
          this.showTips = false
        } else if (timeDisplay > 60.5 && timeDisplay < 63.5) {
          this.currentIndex = 15
          this.currentItem = text['15']
        } else if (timeDisplay > 63.5 && timeDisplay < 66.8) {
          this.currentIndex = 17
          this.currentItem = text['17']
        } else if (timeDisplay > 67 && timeDisplay < 71) {
          this.currentIndex = 18
          this.currentItem = text['18']
        } else if (timeDisplay > 71 && timeDisplay < 73.8) {
          this.currentIndex = 19
          this.currentItem = text['19']
        } else if (timeDisplay > 74 && timeDisplay < 75.5) {
          this.currentIndex = 20
          this.currentItem = text['20']
        } else if (timeDisplay > 76 && timeDisplay < 79) {
          this.currentIndex = 21
          this.currentItem = text['21']
        } else if (timeDisplay > 79.3 && timeDisplay < 82.5) {
          this.currentIndex = 23
          this.currentItem = text['23']
        } else if (timeDisplay > 83 && timeDisplay < 88) {
          this.currentIndex = 24
          this.currentItem = text['24']
        } else if (timeDisplay > 88 && timeDisplay < 93) {
          this.currentIndex = 25
          this.currentItem = text['25']
        } else if (timeDisplay > 94 && timeDisplay < 98) {
          this.showTips = true
          this.currentIndex = 26
          this.currentItem = text['26']
        } else if (timeDisplay > 98 && timeDisplay < 102) {
          this.currentIndex = 27
          this.showTips = false
          this.currentItem = text['27']
        } else if (timeDisplay > 102 && timeDisplay < 105) {
          this.currentIndex = 28
          this.currentItem = text['28']
        } else if (timeDisplay > 105 && timeDisplay < 110) {
          this.currentIndex = 29
          this.currentItem = text['29']
        } else if (timeDisplay > 110) {
          this.currentIndex = ''
          this.currentItem = ''
          this.showEndCover = true
          this.showStartText = false
          let video = document.getElementById('video')
          video.pause()
        }
      })
    },
    // 监听video 是否播放
    listenPlay () {
      document.getElementById('video').addEventListener('play', () => {
        this.videoIsBegin = true
        this.setShare()
      })
      document.getElementById('video').addEventListener('end', () => {
        this.videoIsEnd = true
        this.showEndCover = true
      })
    },
    // 监听video 是否可以播放
    listenCanPlay () {
      document.getElementById('video').addEventListener('canplay', () => {
        this.videoCanplay = true
      })
    },
    onTouchStart (e) {
      this.showImg = false
      let video = document.getElementById('video')
      video.play()
    },
    onTouchEnd (e) {
      if (this.hasPreview && !this.videoIsEnd) {
        document.getElementById('video').pause()
        this.showImg = true
        this.hasCard.push(this.currentItem)
      }
    },
    handleVideoClick () {
      if (this.beforePlay) {
        let video = document.getElementById('video')
        video.play()
        this.beforePlay = false
      }
    },
    playMusic () {
    },
    rePlay () {
      window.location.reload()
    },
    goShare () {
      this.showShare = true
    },
    getWxJDK: function () {
      var t = document.createElement('script')
      t.src = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js',
      document.getElementsByTagName('body')[0].appendChild(t)
    },
    // 显示分享的弹窗
    setShare () {
      let shareIcon = 'https://upload-images.jianshu.io/upload_images/6185311-a02cc816cb366a69.png?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240'
      let shareTitle = `一带一路上的中国名片`
      let shareContent = ''
      let shareLink = window.location.href
      if (/MicroMessenger/.test(navigator.userAgent) || true) {
        let wxConfigParams = {}
        $.ajax({
          url: 'https://api.3g.ifeng.com/weishare_token_api',
          type: 'get',
          dataType: 'jsonp',
          data: {url: window.location.href},
          success: function (data) {
            wxConfigParams.debug = false
            wxConfigParams.appId = data.appId
            wxConfigParams.timestamp = data.timestamp
            wxConfigParams.nonceStr = data.nonceStr
            wxConfigParams.signature = data.signature
            wxConfigParams.jsApiList = ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone']
            wx.config(wxConfigParams)
            wx.ready(function () {
              wx.onMenuShareAppMessage({
                title: shareTitle,
                desc: shareContent,
                link: shareLink,
                imgUrl: shareIcon
              })
              wx.onMenuShareQZone({
                title: shareTitle,
                desc: shareContent,
                link: shareLink,
                imgUrl: shareIcon
              })
              wx.onMenuShareQQ({
                title: shareTitle,
                desc: shareContent,
                link: shareLink,
                imgUrl: shareIcon
              })
              wx.onMenuShareTimeline({
                title: shareTitle,
                link: shareLink,
                imgUrl: shareIcon
              })
            })
          },
          error: function (data) {
          }
        })
      }
    }
  },
  mounted () {
    this.listenPlay()
    this.listenCanPlay()
    this.listenUpdate()
    this.playMusic()
    this.getWxJDK()
  }
}
</script>

<style lang="less">
  @import './common.less';
  *{

    -webkit-touch-callout:none; /*系统默认菜单被禁用*/

    -webkit-user-select:none; /*webkit浏览器*/

    -khtml-user-select:none; /*早期浏览器*/

    -moz-user-select:none;/*火狐*/

    -ms-user-select:none; /*IE10*/

    user-select:none; }
  body {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    75% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  #app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    .shareLayer {
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0, 0.6);
      position: fixed;
      .share-img {
        width: 444 /@base;
        height: 252 /@base;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: 20 /@base;
      }
    }
    .end-cover {
      text-align: center;
      background: #fffaec;
      width: 100vw;
      height: 100vh;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
      font-size: 30 /@base;
      color: #074372;
      z-index: 99999;
      .title-img {
        width: 680 /@base;
        height: 431 /@base;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: 188 /@base;
      }
      .title {
        font-size: 50 /@base;
        width: 100%;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        top: 30%;
      }
      .btn2-container {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 600 /@base;
        display: flex;
        .left {
          width: 284 /@base;
          height: 83 /@base;
          margin-right: 30 /@base;
        }
        .right {
          width: 284 /@base;
          height: 83 /@base;
        }
      }
      .code-container {
        width: 478 /@base;
        height: 433 /@base;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 70 /@base;
        .code-img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .tip-text {
      position: fixed;
      bottom: 30%;
      width: 700 /@base;
      border-radius: 20 /@base;
      background: rgba(0,0,0,0.5);
      left: 50%;
      transform: translate(-50%, -50%);
      color: white;
      animation: fadeIn 2s ease 0s infinite;
      font-size: 20 /@base;
      text-align: center;
    }
    .loose-container {
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,0.8);
      position: fixed;
      left: 0;
      top: 0;
      z-index: 9998;
      .name-card-container {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .name-text {
          font-size: 20 /@base;
          width: 100vw;
          height: auto;
          text-align: center;
          color: white;
          position: relative;
          bottom: -80 /@base;
        }
        .name-card {
          width: 100vw;
          height: auto;
        }
      }
    }
    .and-tip-start {
      width: 100vw;
      height: 100vh;
      font-size: 30 /@base;
      color: gray;
      position: absolute;
      left: 50%;
      top: 55%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%, -50%);
      z-index: 9999;
      animation: fadeIn 2s ease 0s infinite;
    }
    .audio {
      position: absolute;
      bottom: -100 /@base;
      left: -100 /@base;
    }
    .whitetext {
      color: white!important;
    }
    .text-container {
      position: fixed;
      z-index: 9999;
      left: 20 /@base;
      top: 60 /@base;
      color: #074372;
      -webkit-touch-callout: none; /* iOS Safari */

      -webkit-user-select: none; /* Chrome/Safari/Opera */

      -khtml-user-select: none; /* Konqueror */

      -moz-user-select: none; /* Firefox */

      -ms-user-select: none; /* Internet Explorer/Edge */

      user-select: none; /* Non-prefixed version, currently*/
      .name {
        font-size: 50/@base;
      }
      .compony {
        font-size: 30/@base;
        margin-top: 10 /@base;
      }
      .desc {
        font-size: 30/@base;
        margin-top: 20 /@base;
        line-height: 40 /@base;
      }
    }
    .cover-img {
      width: 100vw;
      height: 100vh;
      background: white;
      position: absolute;
      left: 0;
      right: 0;
      z-index: 100;
    }
    .btn-container {
      width: 186 /@base;
      height: 238 /@base;
      position: fixed;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 0;
      z-index: 9999;
      overflow: hidden;
      background-size: 186 /@base auto;
      background-repeat: no-repeat;
      background-image: url("https://upload-images.jianshu.io/upload_images/6185311-22f6d3b6c0c2632a.png?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240");
    }
    .normalbg {
      width: 100vw;
      height: 140vh;
      margin-top: -20vh;
    }
    .beginbg {
      width: 100vw;
      height: 400vh;
      background-image: url("https://upload-images.jianshu.io/upload_images/6185311-718c1105ebca41e7.png");
      background-position: top center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue